import React      from 'react';
import Flux       from '../../flux/Flux';
import LegalTexts from '../LegalTexts';

export default function DataProtection() {
	return <LegalTexts type={Flux.Constants.Legal.Types.PP} />;
}

